import React from 'react';

export default function Restrictions() {
    return(
        <div>
            <h1>React Restrictions page</h1>
        </div>
    )
}
